module.exports = __webpack_public_path__ + "assets/e291cfa2024a10d5f59f672eb507f57e.png";